// @flow
import type { StoreResourceDef } from 'app/core/types'

export const actionPermissions: StoreResourceDef<> = {
  resourceType: 'actionPermissions',
}
